define( function() {
	"use strict";

	return ( /\?/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/ajax/var/rquery.js
 ** module id = 287
 ** module chunks = 0
 **/